<template>
  <div id="app">
    <h1>Google OAuth Login</h1>
    <div v-if="user">
      <p>Welcome, {{ user.name }}!</p>
      <img :src="user.picture" alt="User Picture" />
      <p>Email: {{ user.email }}</p>
    </div>
    <div id="g_id_onload" v-else></div> <!-- Google Sign-In button here -->
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      user: null, // 用户信息
      error: null, // 错误信息
    };
  },
  mounted() {
    window.onload = () => {
      if (typeof window.google === 'undefined' || !window.google.accounts || !window.google.accounts.id) {
        console.error("Google Identity Services (GIS) is not loaded correctly.");
        return;
      }

      window.google.accounts.id.initialize({
        client_id: '341972414995-slcd51t1dsuincn3f69db59sgnjhpl67.apps.googleusercontent.com', // 替换成你自己的客户端 ID
        callback: this.handleCredentialResponse,
      });

      window.google.accounts.id.renderButton(
        document.getElementById('g_id_onload'),
        { theme: 'outline', size: 'large' }
      );
    };
  },
  methods: {
    handleCredentialResponse(response) {
      console.log('Encoded JWT ID token: ' + response.credential);
      this.sendTokenToBackend(response.credential);
    },
    async sendTokenToBackend(token) {
      try {
        const response = await fetch('https://dogcatfoodfactory.top/api/auth/google', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ token }),
          credentials: 'include', // 允许携带凭证
        });

        const data = await response.json();
        if (data.message === 'Authentication successful') {
          this.user = data.user; // 更新用户信息
        } else {
          this.error = 'Authentication failed. Please try again.';
        }
      } catch (error) {
        this.error = 'An error occurred. Please try again later.';
      }
    },
  },
};
</script>

<style scoped>
/* 样式自定义 */
.error {
  color: red;
}
</style>
